/* istanbul ignore file */

const getInternal = () => {
    return Object.freeze({
        PRODUCTION: process.env.NODE_ENV === "production",
        DEVELOPMENT: process.env.NODE_ENV === "development",
        REACT_APP_LOCAL: process.env.REACT_APP_LOCAL,
        REACT_APP_BLOB_STORAGE_PATH: "/static-content",
        REACT_APP_INCLUDE_VENDORS: process.env.REACT_APP_INCLUDE_VENDORS || false,
        REACT_APP_ENABLE_CYPRESS_SETTINGS: process.env.REACT_APP_ENABLE_CYPRESS_SETTINGS || false,
        DEV_URL_OVERRIDE: process.env.DEV_URL_OVERRIDE || "",
        NODE_ENV: process.env.NODE_ENV,
    })
}

const INTERNAL = getInternal()

const getLocalURL = localPort => {
    return INTERNAL.REACT_APP_LOCAL || INTERNAL.DEVELOPMENT ? `http://localhost:${localPort as number}` : ""
}

const getEnvVars = () => {
    return Object.freeze({
        REACT_APP_BLOB_STORAGE_SSR_BASEURL:
            process.env.REACT_APP_BLOB_STORAGE_SSR_BASEURL || "https://ecmbrowsefdsxeuw.azurefd.net",
        PORT: process.env.PORT || 3000,
        NODE_ENV: process.env.NODE_ENV,
        REACT_APP_CDN_BASEURL: process.env.REACT_APP_CDN_BASEURL || "https://xcdn.next.co.uk/content",
        REACT_APP_API_BASEURL_SEARCH:
            process.env.REACT_APP_API_BASEURL_SEARCH || "https://sx-test.next.co.uk/api/search",
        REACT_APP_API_BASEURL_PRODUCT_SUMMARY:
            process.env.REACT_APP_API_BASEURL_PRODUCT_SUMMARY || "https://sx-test.next.co.uk/api/product-summary",
        REACT_APP_API_BASEURL_PRODUCT_AGGREGATOR:
            process.env.REACT_APP_API_BASEURL_PRODUCT_AGGREGATOR ||
            "https://sx-test.next.co.uk/api/product-aggregator/aggregator",
        REACT_APP_API_BASEURL_SEARCH_BANNER: process.env.REACT_APP_API_BASEURL_SEARCH_BANNER || getLocalURL(3339),
        POD_NAME: process.env.POD_NAME,
        REACT_APP_SERVE_PATH_PREFIX: process.env.REACT_APP_SERVE_PATH_PREFIX || "",
        REACT_APP_APP_URL:
            process.env.REACT_APP_APP_URL ||
            (INTERNAL.REACT_APP_LOCAL || INTERNAL.DEVELOPMENT ? "http://localhost:3009" : ""),
        REACT_APP_HEADER_BASEURL: process.env.REACT_APP_HEADER_BASEURL || getLocalURL(3004),
        REACT_APP_HEADER_ASSETS_PATH: process.env.REACT_APP_HEADER_ASSETS_PATH || "/headerstatic",
        REACT_APP_FOOTER_BASEURL: process.env.REACT_APP_FOOTER_BASEURL || getLocalURL(3002),
        REACT_APP_FOOTER_ASSETS_PATH: process.env.REACT_APP_FOOTER_ASSETS_PATH || "/footerstatic",
        REACT_APP_PROD_SUMM_BASEURL: process.env.REACT_APP_PROD_SUMM_BASEURL || getLocalURL(3001),
        REACT_APP_PROD_SUMM_ASSETS_PATH: process.env.REACT_APP_PROD_SUMM_ASSETS_PATH || "/productsummarystatic",
        REACT_APP_SEO_METADATA_BASEURL: process.env.REACT_APP_SEO_METADATA_BASEURL || getLocalURL(3006),
        REACT_APP_USE_TIME_MACHINE_COOKIE: process.env.REACT_APP_USE_TIME_MACHINE_COOKIE || "false",
        ASSETS_PATH: process.env.ASSETS_PATH || "/plpstatic",
        LOG_LEVEL: process.env.LOG_LEVEL,
        FNC_NAME: process.env.FNC_NAME,
        REACT_APP_APPINSIGHTS_KEY: process.env.REACT_APP_APPINSIGHTS_KEY,
        ENVIRONMENT_NAME: process.env.ENVIRONMENT_NAME || "pd",
        USE_LOCAL_STATIC_CONTENT: process.env.USE_LOCAL_STATIC_CONTENT || "true",
        REACT_APP_LAUNCH_DARKLY_APP_ID: process.env.REACT_APP_LAUNCH_DARKLY_APP_ID || "sx-launch-darkly-app-id",
        REACT_APP_LAUNCH_DARKLY_SDK_KEY: process.env.REACT_APP_LAUNCH_DARKLY_SDK_KEY,
        REACT_APP_LAUNCH_DARKLY_BASE_URI: process.env.REACT_APP_LAUNCH_DARKLY_BASE_URI,
        REACT_APP_LAUNCH_DARKLY_EVENTS_URI: process.env.REACT_APP_LAUNCH_DARKLY_EVENTS_URI,
        REACT_APP_LAUNCH_DARKLY_STREAM_URI: process.env.REACT_APP_LAUNCH_DARKLY_STREAM_URI,
        REACT_APP_API_BASEURL_ADVERTS:
            process.env.REACT_APP_API_BASEURL_ADVERTS || "https://sx-test.next.co.uk/api/adverts",
    })
}

export const getVars = () => ({
    ...INTERNAL,
    ...getEnvVars(),
})

export default getVars()
